import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useBrand } from "@/brand";
import Logo from "./Logo";

const links = [
  { href: "#hvorfor", label: "Hvorfor oss" },
  { href: "#avtaler", label: "Strømavtaler" },
  { href: "#infrastruktur", label: "Nett og marked" },
  { href: "#fornybar", label: "100% Fornybar" },
  { href: "#om-oss", label: "Om {BRAND}" },
  { href: "#kontakt", label: "Kontakt" },
  { href: "/privat", label: "Privatkunder" },
];

const Navbar = () => {
  const brand = useBrand();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-[#0B132B]/95 backdrop-blur-md border-b border-white/10 text-white">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#hero" aria-label={`${brand.name} – til forsiden`} data-testid="nav-logo-link">
          <Logo />
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-300" aria-label="Hovedmeny">
          {links.map((l) => (
            <a key={l.href} href={l.href} className="hover:text-emerald-400 transition-colors" data-testid={`nav-link-${l.href.slice(1)}`}>
              {l.label.replace("{BRAND}", brand.name)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="/mine-sider"
            className="hidden lg:inline-flex px-4 py-2.5 rounded-md border border-white/20 text-slate-300 text-sm font-medium hover:text-emerald-400 hover:border-emerald-400/60 transition-colors"
            data-testid="nav-mine-sider"
          >
            Mine sider
          </a>
          <a
            href="/bli-kunde"
            className="hidden sm:inline-flex px-5 py-2.5 rounded-md bg-emerald-500 hover:bg-emerald-400 text-[#0B132B] font-bold text-sm transition-colors shadow-sm"
            data-testid="nav-cta-button"
          >
            Bli kunde
          </a>
          <button
            className="md:hidden p-2 rounded-md text-slate-200 hover:text-emerald-400 transition-colors"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Lukk meny" : "Åpne meny"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-white/10 bg-[#0B132B] px-6 py-4" aria-label="Mobilmeny" data-testid="mobile-menu">
          <ul className="space-y-1 text-sm font-medium text-slate-200">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block py-3 border-b border-white/5 hover:text-emerald-400 transition-colors"
                  data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                >
                  {l.label.replace("{BRAND}", brand.name)}
                </a>
              </li>
            ))}
            <li>
              <a
                href="/mine-sider"
                onClick={() => setOpen(false)}
                className="mt-3 block text-center px-5 py-3 rounded-md border border-white/20 text-slate-300 font-medium hover:text-emerald-400 transition-colors"
                data-testid="mobile-nav-mine-sider"
              >
                Mine sider
              </a>
            </li>
            <li>
              <a
                href="/bli-kunde"
                className="mt-2 block text-center px-5 py-3 rounded-md bg-emerald-500 hover:bg-emerald-400 text-[#0B132B] font-bold transition-colors"
                data-testid="mobile-nav-cta-button"
              >
                Bli kunde
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
